module.exports = __webpack_public_path__ + "img/feature_2.da72abb0.png";